import { ImageContainer, Image } from './Common'

import HeightFillingImage from 'components/Common/HeightFillingImage'
import GoogleCardImage from 'tripPlanner/components/ItemCard/Common/GoogleCardImage'
import type { Place } from 'tripPlanner/types/common'

interface Props {
  place: Place
  tripId: string
  tripItemId: string
  imgId?: string
  imgURL?: string
}

export default function SummaryCardImage({
  place,
  tripId,
  tripItemId,
  imgId,
  imgURL,
}: Props) {
  if (imgURL && imgURL.length > 0) {
    return (
      <ImageContainer>
        <Image src={imgURL} />
      </ImageContainer>
    )
  }
  if (imgId && imgId.length > 0) {
    return (
      <ImageContainer>
        <HeightFillingImage id={imgId} />
      </ImageContainer>
    )
  }
  if (place.type === 'GEO' && place.id) {
    return (
      <ImageContainer>
        <GoogleCardImage
          placeId={place.id}
          title={place.name}
          tripId={tripId}
          tripItemId={tripItemId}
        />
      </ImageContainer>
    )
  }

  if (place.photoUrl) {
    return (
      <ImageContainer>
        <Image src={place.photoUrl} />
      </ImageContainer>
    )
  }

  return null
}
